import Vue from 'vue';
import Vant, { Lazyload } from 'vant';
import 'vant/lib/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import Axios from 'axios';


Vue.use(Lazyload);
Vue.use(Vant);
Vue.config.productionTip = false;

Vue.use(Lazyload, {
    lazyComponent: true,
});
new Vue({
    router,
    store,
    Axios,
    render: (h) => h(App),
}).$mount('#app');